export const VIEWCBD_VER = '1.10';



// WEBPACK FOOTER //
// ./src/appSettings.js